import { SidebarDynamicRules } from "./SidebarDynamicRules";

const getNestedValue = (obj, path) => {
  if (!obj || !path) return undefined;
  const value = path.split(".").reduce((acc, key) => {
    return acc ? acc[key.trim()] : undefined;  // ✅ MUST return here
  }, obj);
  return value;
};
export const applyDynamicRules = (items, formData) => {
  return items.map((item) => {
    const rules = SidebarDynamicRules.filter((r) => r.target === item.id);
    if (!rules.length) return item; // no matching rule, skip

    const newItem = { ...item };
    rules.forEach((rule) => {
      const deps = Array.isArray(rule.dependsOn)
        ? rule.dependsOn
        : [rule.dependsOn];

      const depValues = deps.map((dep) => getNestedValue(formData, dep));

      if (depValues.some((v) => v === undefined)) return;

      const result = rule.condition(...depValues);

      const keys = rule.property.split(".");
      let target = newItem;
      keys.slice(0, -1).forEach((k) => {
        target[k] = target[k] || {};
        target = target[k];
      });
      target[keys[keys.length - 1]] = result;
    });

    return newItem;
  });
};
